import { DefaultChatTransport } from "ai";

export const messageText = (message) =>
  (message?.parts ?? [])
    .filter((part) => part?.type === "text" && typeof part.text === "string")
    .map((part) => part.text)
    .join("");

// Use the supported SDK transport/parser; the backend owns conversation history.
export const createChatTransport = ({ apiUrl, getToken, fetch, agent }) =>
  new DefaultChatTransport({
    api: `${apiUrl}/v1/chat`,
    ...(fetch ? { fetch } : {}),
    headers: () => {
      const token = getToken();
      return token ? { Authorization: `Bearer ${token}` } : {};
    },
    prepareSendMessagesRequest: ({ id, messages }) => {
      const last = messages[messages.length - 1];
      return {
        body: {
          conversationId: id,
          agent,
          message: {
            id: last.id,
            role: "user",
            parts: [{ type: "text", text: messageText(last) }],
          },
        },
      };
    },
  });

// Preserve nutrition defaults and wire behavior.
export const createMealChatTransport = (options) =>
  createChatTransport({ ...options, agent: "nutrition" });
